import React from 'react';
import './assets/style.less';
import { emitter, E_GET_HUD } from '../../event';
import { numberFormat,digitFormat } from '../../CEF';
import ProgressBar from 'react-customizable-progressbar'

const MAX_SPEED = 160;
const MAX_FUEL = 150;
//      API  23851971

type InterInterface = {
    show:boolean;
    hp:number; 
    max_hp:number;
    arm:number;
    breath:number;
    wanted:number;
    weapon:number;
    ammo:number;
    max_ammo:number;
    servername: string;
    servercolor: string;
    online: number;
    money: number;
    satiety: number;
    f7: number;
    sp: boolean;
    speed: number;
    show_speed:number;
    fuel: number;
    vh: number;
    en: boolean;
    door: boolean;
    boot: boolean;
    li:boolean;
    tu:boolean;
    circular_size:number;
}

const importAll = (r:any) => {
    let images:any = {};
    r.keys().map((item:any) => { 
        // Webpack 5 Asset Modules might return the module with .default or the path directly
        const module = r(item);
        return images[item.replace('./', '')] = module.default || module; 
    });
    return images;
}
  
const images = importAll(require.context('./assets', false, /\.(png|jpe?g|svg)$/));
 
  
class HUD extends React.Component<any, InterInterface> {
     
    speed_time: NodeJS.Timeout | undefined;
    constructor(props: any) {
        super(props);
        this.state = {
            show: false,
            hp: 100.0,
            max_hp: 100.0,
            arm: 0.0,
            breath:0.0,
            wanted:0,
            weapon:0,
            ammo:10,
            max_ammo:100,
            servername: 'red',
            servercolor: 'E85A70',
            online: 1000,
            money: 0,
            satiety: 0,
            f7: 0,

            sp: false,
            speed: 0,
            show_speed: 0,
            fuel: 10,
            vh: 1000,
            en: false,
            door: false,
            boot: false,
            li:false,
            tu:false,
        
            circular_size: 0
        }
    }
    unsubscribe = () => {};
    unsubscribe_2 = () => {};
     

    keyup = (e: any) => {
        if( e.keyCode === 118) {
            let next = this.state.f7 + 1;
            this.setState( { f7: next > 2 ? 0 : next })
        }
        return true;
    }
 
    componentWillUnmount = () => {
        this.unsubscribe();
        document.removeEventListener('keyup', this.keyup);   
        window.removeEventListener('resize', this.handleWindowResize);
        if( this.speed_time) clearInterval( this.speed_time );
//        this.unsubscribe_2();
    }
    componentDidMount = () => {
        document.addEventListener('keyup', this.keyup);  
        window.addEventListener('resize', this.handleWindowResize)
        this.unsubscribe = emitter.subscribe(E_GET_HUD, ( data:any ) => this.showHUD(data));
        window.cef.emit("game:hud:setComponentVisible", "interface", false);
        window.cef.emit("game:data:pollPlayerStats", true, 100);
        window.cef.on("game:data:playerStats", (hp:number, max_hp:number, arm:number, breath:number, wanted:number, weapon:number, ammo:number, max_ammo:number, money:number,speed:number) => { 
            this.updateHUD(hp, max_hp, arm, breath, wanted, weapon, ammo, max_ammo, money, speed)
        } )
        this.setState( { circular_size: document.documentElement.clientHeight*0.3  })
    }
    handleWindowResize = () => {// getElementsByClassName("hud_circle")[0].clientHeight
        this.setState( { circular_size: document.documentElement.clientHeight*0.3  })
    }
    updateHUD = (hp:number, max_hp:number, arm:number, breath:number, wanted:number, weapon:number, ammo:number, max_ammo:number, money:number, speed:number) => {
        this.setState({...this.state, hp, max_hp, arm, breath, wanted, weapon, ammo, max_ammo, speed});
        return;
    }
    showHUD = (data:string) => {
        let result:InterInterface = JSON.parse(data, function(key, value) {  return value; });
        // if( result.info === false )
        //     window.cef.set_focus( result.show );
        this.setState({...this.state, ...result });
        if( this.state.sp || result.sp)  {
//            this.updateSpeed();//document.getElementsByClassName("hud_circle")[0].clientHeight
            this.setState( { circular_size: document.documentElement.clientHeight*0.3  })
        }
        return;
    }
    updateSpeed = () => {
        if( Math.ceil( this.state.speed ) !== Math.ceil( this.state.show_speed ) ) { //&& !this.speed_time
            if( this.speed_time ) clearInterval( this.speed_time );
            this.speed_time = setInterval(() => {
                if( Math.ceil( this.state.speed ) === Math.ceil( this.state.show_speed ) && this.speed_time) {
                    clearInterval( this.speed_time );
                    this.speed_time = undefined;
                    return;
                }
                this.setState( { show_speed: this.state.show_speed + ( this.state.show_speed > this.state.speed ? -1 : 1)} )
            }, this.state.speed > this.state.show_speed ? 90 : 45 );
        }
    }
    printWanted = () => {
        let result:JSX.Element[] = [];
        for (let id = 5; id >= 0; id--) {
            result.push( <img src={ images[`_star.svg`]} style={{opacity: id < this.state.wanted ? 1 : 0.5}} alt=''/> ) 
        }
        return result;
    }
    componentDidUpdate = () => {
    }

    getTime = () => {
        let date = new Date();
        return `${digitFormat( date.getHours() )}:${digitFormat(date.getMinutes())}`
    }
    render() { 
        if( this.state.show === false ) 
            return null;

        const vehHp = Math.max(0, Math.ceil(this.state.vh));
        const vehHpPercent = Math.max(0, Math.min(100, Math.round((vehHp / 1000) * 100)));
        const fuelValue = Math.max(0, Math.ceil(this.state.fuel));
        const fuelPercent = Math.max(0, Math.min(100, Math.round((fuelValue / MAX_FUEL) * 100)));
        const vehHpColor = vehHp > 600 ? '#5ef59b' : (vehHp > 350 ? '#f7c15b' : '#ff6b6b');
        const fuelColor = fuelValue > 35 ? '#5ed8ff' : (fuelValue > 15 ? '#ffd36a' : '#ff8d6b');

        return <>
            {this.state.sp === true ?
            <div className="hud_sp" style={{ opacity: this.state.f7 === 0 ? 1 : ( this.state.f7 === 1 ? 0.5 : 0 )}}>
                <div className="hud_bg"/>
                    <div className="hud_circle">
                        <ProgressBar
                            progress={this.state.speed > MAX_SPEED ? MAX_SPEED: this.state.speed }
                            steps={MAX_SPEED}
                            radius={this.state.circular_size/2.4}
                            rotate={135}
                            cut={90}
                            strokeColor={"#ffffff"}
                            trackStrokeColor={"#ffffff"}
                            strokeLinecap="square"
                            trackStrokeLinecap="square"
                            strokeWidth={this.state.circular_size/20}
                            trackStrokeWidth={this.state.circular_size/20}
                            // trackTransition={"2s ease"}
                            // transition={"2.5s ease"}
                        />
                        <h1>{ Math.ceil( this.state.speed )}</h1>
                        <h2>KM/H</h2>
                        <div className="hud_status_stack">
                            <div className="hud_status_bar">
                                <div className="hud_status_head">
                                    <img src={ images[`_heal.svg`]} alt=''/>
                                    <span>{vehHp} HP</span>
                                </div>
                                <div className="hud_status_track">
                                    <div style={{ width: `${vehHpPercent}%`, backgroundColor: vehHpColor }}></div>
                                </div>
                            </div>
                            <div className="hud_status_bar">
                                <div className="hud_status_head">
                                    <img src={ images[`_s_fuel.svg`]} alt=''/>
                                    <span>{fuelValue} L</span>
                                </div>
                                <div className="hud_status_track">
                                    <div style={{ width: `${fuelPercent}%`, backgroundColor: fuelColor }}></div>
                                </div>
                            </div>
                        </div>
                        <div className="hud_s_data_left">
                            <img src={ images[`_s_boot_on.svg`]} style={{ 
                                opacity: this.state.boot ? 0.8 : 0.3,
                                backgroundColor: this.state.boot ?  "rgba(84, 255, 84, 0.172)" : "rgba(248, 142, 61, 0.172)",
                                width: this.state.boot ?  "2.5vh" : "2vh"}} alt=''/> 
                        </div>
                        <div className="hud_s_data_right">
                            <img src={ images[`_s_turbo_on.svg`]} style={{ 
                                opacity: this.state.tu ? 0.8 : 0.3,
                                backgroundColor: this.state.tu ?  "rgba(84, 255, 84, 0.172)" : "rgba(248, 142, 61, 0.172)",
                                width: this.state.tu ?  "2.5vh" : "2vh"}} alt=''/> 
                        </div>
                        <div className="hud_s_data">
                            <img src={ images[`_s_engine_on.svg`]} style={{ 
                                opacity: this.state.en ? 0.8 : 0.3,
                                backgroundColor: this.state.en ?  "rgba(84, 255, 84, 0.172)" : "rgba(248, 142, 61, 0.172)",
                                width: this.state.en ?  "2.5vh" : "2vh"}}  alt=''/> 
                            <img src={ images[`_s_light_on.svg`]} style={{ 
                                opacity: this.state.li ? 0.8 : 0.3,
                                backgroundColor: this.state.li ?  "rgba(84, 255, 84, 0.172)" : "rgba(248, 142, 61, 0.172)",
                                width: this.state.li ?  "2.5vh" : "2vh"}} alt=''/> 
                            <img src={ images[`_s_door_on.svg`]} style={{ 
                                opacity: this.state.door ? 0.3 : 0.8,
                                backgroundColor: this.state.door ?  "rgba(248, 142, 61, 0.172)" : "rgba(84, 255, 84, 0.172)",
                                width: this.state.door ?  "2vh" : "2.5vh"}} alt=''/> 
                        </div>
                </div>
            </div> : null }
            <div className="hud_main" style={{ opacity: this.state.f7 === 0 ? 1 : ( this.state.f7 === 1 ? 0.5 : 0 )}}>
                <div className="hud_bg"/>
                <div className="hud_weap">
                     <div className="hud_weap_prev">
                        <img src={ images[`w${this.state.weapon}.png`]} alt=''/> 
                        <img src={ images[`_weap.svg`]} alt=''/>
                    </div>
                    { this.state.max_ammo > 0 && this.state.weapon > 0 ? 
                    <div className="hud_weap_ammo">
                        <h1>{this.state.ammo}</h1>
                        <h1>{this.state.max_ammo - this.state.ammo}</h1>
                    </div> : null }
                </div>
                <div className="hud_data">
                    <div className="hud_server">
                        <div className="hud_server_left">
                            <img src={ images[`_logo.png`]} alt=''/>
                            <div className="hud_server_center">
                                <h1>ADVANCE</h1>
                                <h2 style={{color:`#${this.state.servercolor}`}}>{this.state.servername.toUpperCase()}</h2>
                            </div>
                        </div>
                        <div className="hud_time">
                            <h1>{this.getTime()}</h1>
                            <div>
                                    <img src={ images[`_users.svg`]} alt=''/>
                                    <h1>{this.state.online}</h1>
                            </div>

                        </div>
                    </div>
                    <div className="hud_money">$ { numberFormat( this.state.money )  }</div>
                    <div className="hud_bar">
                        <img src={ images[`_heal.svg`]} alt=''/>
                        <div className="hud_hp" style={{backgroundColor: '#E85A7044'}}>
                            <div style={{width: `${this.state.hp > 100 ? 100 : this.state.hp}%`, backgroundColor: '#E85A70'}}></div>
                        </div>
                        <h1>{ Math.ceil(this.state.hp) }</h1>
                    </div>
                    {this.state.arm > 0 ?
                    <div className="hud_bar">
                        <img src={ images[`_armour.svg`]} alt=''/>
                        <div className="hud_hp" style={{backgroundColor: '#ffffff44'}}>
                            <div style={{width: `${this.state.arm > 100 ? 100 : this.state.arm}%`, backgroundColor: '#ffffff'}}></div>
                        </div>
                        <h1>{ Math.ceil(this.state.arm)}</h1>
                    </div> : null }
                    {this.state.wanted > 0 ? 
                     <div className="hud_star">
                        {this.printWanted()}
                    </div> : null
                    }
                    {this.state.satiety > 0 ?
                        <div className="hud_sati"> <img src={ images[`_satiety.svg`]} alt=''/> </div>:null
                    } 
                </div>
            </div>
        </>
    }
}

export default HUD;
